import { Component, OnInit, Input, Output, EventEmitter, ElementRef,OnChanges,SimpleChanges } from '@angular/core';
import {CommonService} from '../../app/common.service';
import {ActivatedRoute} from '@angular/router';
@Component({
	selector: 'components-approach',
	templateUrl: './components.approach.html',
	styleUrls: ['./components.approach.css']
})
export class ComponentsApproach implements OnInit {

  @Input() theme: any;
  @Input() isTencent: boolean = false;
  @Input() isFirst: boolean;
  @Input() isShowFull: boolean = true;
  @Input() isShowProgress: boolean;
  @Output() onGoCourse = new EventEmitter<any>()

  label: any;
  assetsRoute: string = "../../assets";
  isCamp: boolean = false;
  buttonTheme: any = {
    'position':'inherit',
    'fontSize': 'fontSize15',
    'buttonElem':[
      {
        'color': 'blue',
        'text': '',
        'className': 'inlineBlockRadiusBtn width-100 margin-auto'
      }
    ]
  }; //按钮主题
  type : string;//是否为pc横版
	constructor(
	  private el: ElementRef,
    private commonService:CommonService,
    private route: ActivatedRoute,
  ) {}

	ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.label = this.theme.label
    this.isCamp = !!localStorage.getItem('skuId');
    this.buttonTheme.buttonElem[0].text = this.theme.btnTxt;
    this.buttonTheme.buttonElem[0].className = this.theme.colorSystem === 'light'? 'inlineBlockRadiusBtn width-60 margin-auto':this.buttonTheme.buttonElem[0].className;
    this.route.queryParams.subscribe(queryParams=>{
      this.type = queryParams['type'];
    })
    if(this.type){
      this.theme.desc = '请点击左侧边栏中能力考核进行学习 ~';
    }
    console.log('approach')
	}


	ngAfterViewInit() {

	}



}



// WEBPACK FOOTER //
// ./src/component/approach/components.approach.ts